import { render, staticRenderFns } from "./MessageTypeSelector.vue?vue&type=template&id=86f5d58c&scoped=true&"
import script from "./MessageTypeSelector.vue?vue&type=script&lang=js&"
export * from "./MessageTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeSelector.vue?vue&type=style&index=0&id=86f5d58c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f5d58c",
  null
  
)

export default component.exports